import { jsxs as t, jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 12C14.7568 12 17 9.7568 17 7C17 4.2432 14.7568 2 12 2C9.2432 2 7 4.2432 7 7C7 9.7568 9.2432 12 12 12ZM12 4C13.6543 4 15 5.3457 15 7C15 8.6543 13.6543 10 12 10C10.3457 10 9 8.6543 9 7C9 5.3457 10.3457 4 12 4Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 14C6.4863 14 2 17 2 22H22C22 17.5889 17.5137 14 12 14ZM4.4667 20C5.5684 17.6734 8.5249 16 12 16C15.4751 16 18.4315 17.6734 19.5333 20H4.4667Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
